/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
/* eslint-disable react/jsx-no-undef */
import React, { useRef } from 'react'
import AnimatedModel from '../../../../components/Animation/AnimatedModel'
import AnimatedHeading from '../../../../components/Animation/AnimatedHeading'
import UpdateButton from '../../../../components/UpdateButton'

const DuplicateTabCloseModal = ({handleClose, tittle, message, buttonName, handleOnCLickActivate, loadingActivation, additionalMessage, textMessage, textAreaMsg, setTextAreaMsg, emptyField,setEmptyField,userList,disabled,CancelButton,data_testid,preferenceList, isDropdownOpen,setIsDropdownOpen, handleAllowDuplicateClose,handleSelectPreference, selectedPreference,dupLoadingBtn}) => {


    return (
        <AnimatedModel
            Children={
                <div data-te-modal-init="" className="fixed left-0 top-0 z-[1055] h-full w-full overflow-y-auto overflow-x-hidden outline-none bg-black bg-opacity-50" id="modalforDeactivate" tabIndex="-1" aria-labelledby="modalforDeactivateTitle" aria-modal="true" role="dialog" data-te-open="true" style={{display: "block"}}>
                    <div data-te-modal-dialog-ref="" className="pointer-events-none relative flex min-h-[calc(100%-1rem)] w-auto translate-y-[-50px] items-center opacity-1 transition-all duration-300 ease-in-out min-w-[450px] mx-auto max-w-[450px]">
                        <div className="pointer-events-auto flex w-full flex-col rounded-[16px] border-none bg-white bg-clip-padding text-current shadow-lg outline-none min-w-[450px] mx-auto max-w-[450px] px-8 py-8 relative">
                            {/* <img src='/images/cross_mark_gray.svg' alt='icon' className='w-[20px] h-[20px] absolute top-3 right-3 cursor-pointer' onClick={() => handleClose()} /> */}
                            <AnimatedHeading className="text-xl font-semibold text-[#000000] text-center" Children={tittle} />
                            <div className="relative pt-[13px]">
                                <AnimatedHeading className="text-center text-lg font-normal text-[#031624]" Children={message} />
                            </div>
                            <div className="mt-[13px] w-full">
                                <div className={`-mx-2.5 flex justify-center`}>
                                    <div className='px-2.5 w-1/3'>
                                        <button
                                            onClick={() => handleClose()} 
                                            id="Cancel"
                                            disabled={disabled||dupLoadingBtn}
                                            className="py-2.5 px-4 rounded-[16px] border border-[#972E4C] text-lg font-semibold text-[#972E4C] w-fit" 
                                        > {CancelButton ? 'No' : 'Cancel'}
                                        </button>
                                    </div>
                                    <div className='px-2.5 w-1/3'>
                                        <UpdateButton
                                            data_testid={data_testid} 
                                            loading={dupLoadingBtn} 
                                            ButtonName={buttonName} 
                                            handleOnCLick={handleAllowDuplicateClose} 
                                            classKey={`py-2.5 px-7 rounded-[16px] border border-[#972E4C]  hover:bg-[#AB556E] ${dupLoadingBtn ? 'bg-[#777C88]' : 'bg-[#972E4C]' } focus:bg-[#863B50] text-lg font-semibold text-[#FFFFFF] hover:duration-75 reset_password_conf w-fit`}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        />
    )
}

export default DuplicateTabCloseModal